import type { FC, PropsWithChildren } from 'react'
import type { UserRole } from '~shared/types'
import { useDashboardPermission } from '@/entities/user'
import { Navigate } from 'react-router-dom'

type RouteGuardProps = {
  role: UserRole
}

export const RouteGuard: FC<PropsWithChildren<RouteGuardProps>> = ({
  role,
  children,
}) => {
  const hasPermission = useDashboardPermission({
    role,
  })

  if (!hasPermission) {
    return (
      <Navigate
        to="/"
        replace
        state={{ from: location.pathname }}
      />
    )
  }

  return children
}
